// extracted by mini-css-extract-plugin
module.exports = {"navbarDefaultBg":"#2a3f49","footer":"style__footer__2-w4e","wrapper":"style__wrapper__fdORs"};